import {
	MANAGE_ARTICLES_GET_ARTICLES,
	MANAGE_ARTICLES_GET_ARTICLES_FAILURE,
	MANAGE_ARTICLES_GET_ARTICLES_SUCCESS,
	MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES,
	MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES_FAILURE,
	MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES_SUCCESS,
	MANAGE_ARTICLES_REMOVE_ARTICLES,
	MANAGE_ARTICLES_REMOVE_ARTICLES_FAILURE,
	MANAGE_ARTICLES_REMOVE_ARTICLES_SUCCESS,
	MANAGE_ARTICLES_PROPS_CHANGED
} from "./actions";
import {debug, find, removeElem} from "../../../utility/functions";

const initialState = {
	loading: false,
	articles: null,
	article: null,
	index: null,
	inRemoveMode: false,
	removing: false,
	inPublishMode: false,
	publishing: false,
	pagination: null,
	clickedArticleId: null
};

export const manageArticlesReducer = (state = initialState, action = {}) => {
	const articles = state.articles? [...state.articles] : [];
	switch (action.type) {
		case MANAGE_ARTICLES_GET_ARTICLES:
			return {
				...state,
				loading: true,
			};
		case MANAGE_ARTICLES_GET_ARTICLES_SUCCESS:
			return {
				...state,
				articles: action.articles,
				pagination: action.pagination,
				loading: false,
			};
		case MANAGE_ARTICLES_GET_ARTICLES_FAILURE:
			return {
				...state,
				loading: false,
			};

		case MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES:
			return {
				...state,
				publishing: true,
			};
		case MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES_SUCCESS:
			articles[action.index] = action.article;
			return {
				...state,
				publishing: false,
				inPublishMode: false,
				article: null,
				index: null,
				articles,
			};
		case MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES_FAILURE:
			return {
				...state,
				publishing: false,
				inPublishMode: false,
			};
		case MANAGE_ARTICLES_REMOVE_ARTICLES:
			return {
				...state,
				removing: true,
			};
		case MANAGE_ARTICLES_REMOVE_ARTICLES_SUCCESS:
			debug("Action Article", action.article)
			return {
				...state,
				articles: removeElem(state.articles, 'id', find(action.article, 'id')),
				removing: false,
				inRemoveMode: false,
				article: null,
				index: null,

			};
		case MANAGE_ARTICLES_REMOVE_ARTICLES_FAILURE:
			return {
				...state,
				removing: false,
				inRemoveMode: false,
			};
		case MANAGE_ARTICLES_PROPS_CHANGED:
			return {
				...state,
				...action,
			};
		default:
			return state;
	}
};